import { Check, workDef } from './check.class';
import { merge } from 'lodash';

export class CheckMeca extends Check {
  data: {
    timemeter?: number;
    thermalAjust?: number;
    isolation: {
      phase1?: number;
      phase2?: number;
      phase3?: number;
      conforme?: boolean;
    },
    measures: Array<{tension?: number, intensity?: number, power?: number}>,
    intensityMeasuresImpossible?: boolean;
    works: any;
    comments?: string;
  };

  constructor(obj?: any) {
    super(CheckMeca.type);

    if(!obj) obj = {};

    this.data = merge({
        isolation: {
        },
        measures: [{}, {}, {}],
        works: CheckMeca.getEmptyWorks(),
        comments: '',
      },
      obj.data
    );
  }

  public static type = 'meca';
  public static label = 'Organes mécaniques';

  public static getEmptyWorks() {
    let works = {};
    this.listWorks.forEach((workDef) => {
      works[workDef.field] = {
        done: null,
        comment: '',
      };
      if (workDef.subFields) {
        workDef.subFields.forEach((subField) => {
          works[workDef.field][subField.field] = null;
        })
      }
    });
    return works;
  }

  public static listWorks: Array<workDef> = [
    {
      label: 'Serrage des brides',
      field: 'flangesClamping',
      checker: true,
      comment: true,
    }, {
      label: 'Remplacement d\'huile de garniture ou niveau',
      field: 'oilReplacement',
      checker: true,
      comment: true,
    }, {
      label: 'Présence point d\'eau',
      field: 'waterPresence',
      checker: true,
      comment: true,
    }, {
      label: 'Nettoyage poires',
      field: 'mugClean',
      checker: true,
      comment: true,
    }, {
      label: 'Nettoyage poste',
      field: 'posteClean',
      checker: true,
      comment: true,
    }, {
      label: 'Nettoyage pompes',
      field: 'pumpClean',
      checker: true,
      comment: true,
    }, {
      label: 'Nettoyage local',
      field: 'localClean',
      checker: true,
      comment: true,
    },
  ];
}



// WEBPACK FOOTER //
// ./src/app/models/check/check-meca.class.ts